export const AcceptBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="68"
    fill="none"
    viewBox="0 0 68 68"
    {...props}>
    <rect
      width="60"
      height="60"
      x="4"
      y="4"
      fill="#DEF3FF"
      rx="28"></rect>
    <rect
      width="60"
      height="60"
      x="4"
      y="4"
      stroke="#F1FAFF"
      strokeWidth="8"
      rx="28"></rect>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M29.475 34l3.012 3.025 6.038-6.05"></path>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M32.437 22.063c.863-.738 2.275-.738 3.15 0l1.975 1.7c.375.324 1.075.587 1.575.587h2.125a2.422 2.422 0 012.413 2.412v2.125c0 .488.262 1.2.587 1.575l1.7 1.976c.738.862.738 2.274 0 3.15l-1.7 1.974c-.325.376-.587 1.076-.587 1.576v2.125a2.422 2.422 0 01-2.413 2.412h-2.125c-.487 0-1.2.263-1.575.588l-1.975 1.7c-.862.737-2.275.737-3.15 0l-1.975-1.7c-.375-.325-1.075-.588-1.575-.588h-2.162a2.422 2.422 0 01-2.413-2.412v-2.138c0-.487-.262-1.188-.575-1.563l-1.687-1.987c-.725-.863-.725-2.263 0-3.125l1.687-1.988c.313-.375.575-1.075.575-1.562v-2.15a2.422 2.422 0 012.413-2.413h2.162c.488 0 1.2-.262 1.575-.587l1.975-1.688z"></path>
  </svg>
);
